// src/modules/app-views/account/pages/Init/modals/ChangePasswordModal/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { LockOutlined } from '@ant-design/icons';
import GenericModal from 'components/core/GenericModal';
import useZustand from 'hooks/useZustand';
import appService from 'services/appService';
import FirebaseService from 'services/FirebaseService';
import currentPasswordStep from './Step1';
import newPasswordStep from './Step2';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ChangePasswordModal = ({ show, setShow, afterClose }) => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const storedUser = useZustand('auth', 'user');

  // ---------------------------------------------------------------------------
  // 2. HOOKS & REFS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 3. LOCAL VARIABLES I
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 4. LOCAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 5. EFFECTS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 6. HANDLERS
  // ---------------------------------------------------------------------------
  const handleFinish = async ({ form }) => {
    const newPassword = form?.getFieldValue('newPassword');
    const confirmPassword = form?.getFieldValue('confirmPassword');

    // Validate passwords match
    if (newPassword !== confirmPassword) {
      await appService.message({ flag: 'w', text: 'passwords_do_not_match' });
      return false;
    }

    try {
      // Update password in Firebase
      await FirebaseService.updateUserPassword(newPassword);

      // Show success notification
      appService.notification({
        flag: 'success',
        title: 'password_changed_success_title',
        description: 'password_changed_success_description',
        duration: 5,
      });

      return true; // Close modal
    } catch (err) {
      console.error('[ChangePasswordModal] Error updating password:', err);

      const errorCode = err?.message || '';
      if (errorCode.includes('auth/weak-password')) {
        await appService.message({ flag: 'e', text: 'password_too_weak' });
      } else if (errorCode.includes('auth/requires-recent-login')) {
        await appService.message({ flag: 'e', text: 'session_expired_relogin' });
      } else {
        await appService.message({ flag: 'e', text: 'password_change_failed' });
      }

      return false; // Keep modal open
    }
  };

  // ---------------------------------------------------------------------------
  // 7. LOCAL VARIABLES II
  // ---------------------------------------------------------------------------
  const steps = useMemo(
    () => [
      // Step 1: Current password
      currentPasswordStep({ storedUser }),

      // Step 2: New password
      newPasswordStep(),
    ],
    [storedUser]
  );

  // ---------------------------------------------------------------------------
  // 8. EFFECTS II
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 9. UI
  // ---------------------------------------------------------------------------
  return (
    <GenericModal
      show={show}
      setShow={setShow}
      icon={<LockOutlined />}
      title="change_password"
      steps={steps}
      onFinish={handleFinish}
      afterClose={afterClose}
      width={420}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ChangePasswordModal;

// *******************************************************************************
// HELPERS
// *******************************************************************************
